import { defineComponent as _defineComponent } from 'vue'
import { userEnv } from '@tencent/wphk-base-utils';
import { ScreenDialog } from '@tencent/wphk-ui';
import { computed, ref } from 'vue-demi';
import { i18n } from '../../i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'wx-share',
  setup(__props, { expose }) {

expose({ showDialog, hideDialog });

/** 微信分享弹窗 */
const wxShareDialog = ref<InstanceType<typeof ScreenDialog> | null>(null);
/** 微信分享图片 */
const guideWxImg = computed(() => (userEnv.isInMiniProgram() ? i18n('guideMpImgUrl') : i18n('guideWxImgUrl')));

function showDialog() {
  wxShareDialog.value?.show();
}

function hideDialog() {
  wxShareDialog.value?.hide();
}

return { __sfc: true,wxShareDialog, guideWxImg, showDialog, hideDialog, ScreenDialog }
}

})